import "components/form/Input/Input.scss";

function Input(props) {
  return (
    <input { ...props }/>
  );
}

export default Input;
